<template>
  <button v-tippy="{placement: 'top', arrow: true}" :title="label" @click.prevent="onClick">
    <i qaid="bulk-expand-button" class="material-icons">{{ icon }}</i>
  </button>
</template>
<script>
export default {
  name: 'PlpBulkExpandButton',
  props: {
    isExpanded: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    icon() {
      return this.isExpanded ? 'indeterminate_check_box' : 'add_box';
    },
    label() {
      return this.bp(this.isExpanded ? 'skuGrid.B2B.collapse' : 'skuGrid.B2B.expand');
    },
  },
  methods: {
    onClick() {
      this.$emit('click');
    },
  },
};
</script>
